import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Panel, PanelHeader } from "@/components/common/Panel";
import { fromNow } from "@/lib/format";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// UI-02: activity derives from the append-only audit stream, never from synthetic rows.
export function ActivityFeed({ limit = 8 }) {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => {
    let alive = true;
    const tick = () => axios.get(`${API}/activity`, { params: { limit } }).then((r) => alive && setItems(r.data.items)).catch(() => alive && setItems((x) => x || []));
    tick();
    const t = setInterval(tick, 45000);
    return () => { alive = false; clearInterval(t); };
  }, [limit]);
  return (
    <Panel data-testid="activity-feed">
      <PanelHeader title="Activity" />
      <div className="space-y-3 p-4">
        {items === null && <div className="text-xs text-ink-muted">Loading…</div>}
        {items?.length === 0 && <div className="text-sm text-ink-2">No recorded activity yet. Actions across matters, documents and drafts appear here from the audit log.</div>}
        {items?.map((a) => (
          <button key={a.id} onClick={() => a.to && navigate(a.to)} className="flex w-full gap-3 text-left" data-testid={`activity-${a.id}`}>
            <div className="mt-1 h-2 w-2 shrink-0 rounded-full bg-copper" />
            <div className="text-sm">
              <span className="font-medium text-ink">{a.actor}</span> <span className="text-ink-2">{a.text}</span>
              <div className="text-xs text-ink-muted">{fromNow(a.at)}</div>
            </div>
          </button>
        ))}
      </div>
    </Panel>
  );
}
